export enum LOCALES {
  EN_US = "en-US",
}
